module.exports = __webpack_public_path__ + "static/media/autoplay_next.48840c54.svg";